/**
 * How far from a node's centre a TAP still picks it, by the pointer that tapped.
 *
 * A node's own floor is 13px of radius on the flat canvas, which at overview
 * zoom on a phone is a 26px target round a dot two to twelve pixels across —
 * and most nodes there have had their caption decluttered away, so the caption's
 * coarse-pointer hit area does not reach them. A missed tap either deselected or
 * landed on a neighbour. A finger gets 22px: about a 44px target, the thumb's
 * size every other control here is lifted toward (D335).
 *
 * For the tap's resolution only. The press that arms a stretch keeps the
 * narrow reach, so a wider target does not turn more of the field into a node
 * drag and take the pan away from it (`NeuralCanvas`'s `onDown`). On the flat
 * canvas nearest still wins, so a wider reach cannot steal a tap from a closer
 * node; the spatial view picks the mark nearest the eye instead, so it tries the
 * wider reach only once the ordinary one has found nothing (`SpatialCanvas`).
 */
export const TOUCH_REACH = 22

/** The floor for this event's pointer, or undefined for each canvas's own. */
export function tapReach(e: { pointerType?: string }): number | undefined {
  return e.pointerType === 'touch' ? TOUCH_REACH : undefined
}
